import {
  useMutation,
  UseMutationResult,
} from '@tanstack/react-query';
import getRemoteSdp from 'views/EMR/components/AIAssistant/transport';

export type RealTimeGetRemoteSdpRequest = {
  localSdp: string;
  realTimeToken: string;
};

export default function useGetRemoteSdp(): UseMutationResult<
  string, Error, RealTimeGetRemoteSdpRequest> {
  return useMutation<string, Error, RealTimeGetRemoteSdpRequest>({
    mutationFn: getRemoteSdp,
  });
}
